import React from "react";
import _ from "lodash";
import { Box, Separator, Text } from "@showitinc/showit-wc";
import ViewPanel from "../ViewPanel";
import ButtonBar from "../SetupButtonBar";
import { toUnicode } from "../../../utils/DomainUtils";

function PreferredDomain({ blogSetup, actions }) {
  const { setupData, migrationRequired } = blogSetup;
  const { blog_domain_name: blogDomain } = setupData;

  const message = migrationRequired
    ? "Once your blog is migrated it will be available at:"
    : "Once your blog is setup it will be available at:";

  return (
    <ViewPanel>
      {{
        content: (
          <>
            <Text variant="heading-2" variantStyle="strong">
              Blog Domain
            </Text>
            <Separator />
            <Box mb="3">
              <Text>{message}</Text>
            </Box>
            <Box mb="3">
              <Text variant="body-large" variantStyle="strong">
                {toUnicode(blogDomain || "")}
              </Text>
            </Box>
          </>
        ),
        actions: (
          <ButtonBar
            onForward={actions.goToNextStep}
            onBack={actions.goToPrevStep}
            allowForward
            allowBack
          />
        ),
      }}
    </ViewPanel>
  );
}

export default PreferredDomain;
